<template>
<div class="info">
	<div class="title">投保信息</div>
	<Form :label-width="125" class="mt15">
	    <FormItem label="参保公司：" class="w600">
	        {{info.companyName}}
	    </FormItem>
	</Form>
</div>
</template>
<script>
export default {
	components:{},
	props:{
		info:Object
	},
	computed:{
	},
	methods:{
	}
}
</script>
<style lang="less" scoped>
	.img{
		display:flex;
		flex-wrap:wrap;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/lineWork/common/applicantInfo.vue